import { Action, Dispatch, MiddlewareAPI } from 'redux'
import { debug, isObjectLike } from '../../app/shared/utils/lang'

type MiddlewareFn<S, A extends Action> = (api: MiddlewareAPI<S>) => (next: Dispatch<S>) => (action: A) => A

export const actionToPlainObject: MiddlewareFn<{}, Action> = (store) => (next) => (action) => {
  if (isObjectLike(action)) {
    return next({ ...action })
  }
  throw new Error(`action must be an object: ${debug(action)}`)
}



// WEBPACK FOOTER //
// ./src/modules/store/pure-object-middleware.ts